<template>
  <v-app>
    <v-main>
      <v-row no-gutters align="center" justify="center">
        <v-col cols="12" md="6" lg="4" class="pt-0">
          <router-view />
        </v-col>
      </v-row>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  })
};
</script>

<style>
html {
  overflow: auto;
}
</style>
